import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");
  const [retrying, setRetrying] = useState(false);

  const retry = async () => {
    setRetrying(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        booking_id: bookingId,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
      setRetrying(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#090909] flex flex-col items-center justify-center px-6 py-24">
      <div className="w-full max-w-md text-center">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <div data-testid="payment-cancel-view">
          <XCircle className="h-10 w-10 text-[#A3A3A3] mx-auto" />
          <h1 className="font-display text-4xl mt-6 text-[#F5F5F5]">Payment cancelled.</h1>
          <p className="mt-3 text-sm text-[#A3A3A3] font-light">
            No charge was made. Your booking request is saved but your date
            isn't reserved until the deposit clears.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            {bookingId && (
              <Button
                data-testid="payment-retry-button"
                onClick={retry}
                disabled={retrying}
                className="rounded-sm bg-[#D98B48] hover:bg-[#F0A562] text-[#090909] font-medium px-8 py-6"
              >
                {retrying ? (
                  <span className="inline-flex items-center gap-2">
                    <Loader2 className="h-4 w-4 animate-spin" /> Loading checkout…
                  </span>
                ) : (
                  "Try the deposit again"
                )}
              </Button>
            )}
            <Button asChild variant="outline" data-testid="payment-cancel-home-button" className="rounded-sm border-white/20 bg-transparent text-[#F5F5F5] hover:bg-white/10 px-8 py-6">
              <Link to="/">Back to Estielle</Link>
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
}
